import { IEmployeeGroup } from "../../../domain/employeeGroups/IEmployeeGroup";
import { mapEmployee } from "./mapEmployee";

export const mapEmployeeGroup = (x: any): IEmployeeGroup => ({
    id: x.id,
    name: x.name,
    sortOrder: x.sortOrder,
    links: (x.links || []).map(mapEmployee)
});
